export default __webpack_public_path__ + "static/media/home-page-rule-your-data.15584843.png";